"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.XirrDescriptor = void 0;
var PluggableXirr_1 = require("./PluggableXirr");
var constants_1 = require("../constants");
var XirrDescriptor = /** @class */ (function () {
    function XirrDescriptor() {
    }
    XirrDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableXirr_1.PluggableXirr(params); };
    };
    XirrDescriptor.prototype.getSizeInfo = function (_insight, layoutDescriptor, settings) {
        return {
            width: {
                default: 2,
                min: 2,
                max: layoutDescriptor.gridColumnsCount,
            },
            height: {
                default: this.getDefaultHeight(settings.enableKDWidgetCustomHeight),
                min: this.getMinHeight(settings.enableKDWidgetCustomHeight),
                max: this.getMaxHeight(settings.enableKDWidgetCustomHeight),
            },
        };
    };
    XirrDescriptor.prototype.getDefaultHeight = function (enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT;
        }
        return 8;
    };
    XirrDescriptor.prototype.getMinHeight = function (enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT;
        }
        return 6;
    };
    XirrDescriptor.prototype.getMaxHeight = function (enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT;
        }
        return constants_1.MAX_VISUALIZATION_HEIGHT;
    };
    XirrDescriptor.prototype.applyDrillDown = function (insight) {
        return insight;
    };
    return XirrDescriptor;
}());
exports.XirrDescriptor = XirrDescriptor;
//# sourceMappingURL=XirrDescriptor.js.map